// 商品主数据API
export default {
  // 商品主数据列表查询
  LIST_PRODUCT: '/maindata/product/listProduct',
  /**商品列表-所有子类 */
  GOODS_CATEGORY_API: '/maindata/productDetail/listProductDetail',
  // 商品主数据创建
  PRODUCT_INSERT: '/maindata/product/insertProduct',
  // 商品主数据修改
  PRODUCT_UPDATE: '/maindata/product/updateProduct',
  // 商品主数据详情查询
  PRODUCT_DETAIL: '/maindata/product/getProductDetail',
  // 校验商品主数据中文名称是否存在
  CHECK_PRODUCT_DISPLAY_NAME: '/maindata/product/checkProductChName',
  // 删除商品主数据
  PRODUCT_DELETE: '/maindata/product/deleteProduct',
  // 禁用商品主数据
  PRODUCT_STATUS_UPDATE: '/maindata/product/updateProductStatus',
  // 放弃操作
  CANCEL_MOD: '/maindata/product/cancelMod',
  // 导出商品主数据
  PRODUCT_EXPORT: '/maindata/product/exportProduct',
  // 导入商品主数据
  PRODUCT_IMPORT: '/maindata/product/importProduct',
  // 导出子类商品主数据
  PRODUCT_CHILD_EXPORT: '/maindata/productDetail/exportProductDetail',
  // 商品明细列表查询
  LIST_DETAIL_PRODUCT: '/maindata/productDetail/listProductDetail',
  // 校验商品明细显示名称是否存在
  CHECK_DETAIL_PRODUCT_DISPLAY_NAME: '/maindata/productDetail/checkProductDisplayName',
  // 删除商品明细
  DETAIL_PRODUCT_DELETE: '/maindata/productDetail/deleteDataDict',
  // 启用/禁用商品明细
  DETAIL_PRODUCT_STATUS_UPDATE: '/maindata/productDetail/updateDetailProductStatus',
  // 合并商品明细
  DETAIL_PRODUCT_MERGE: '/maindata/productDetail/mergeProduct',
  // 海关信息详情
  CUSTOMS_DET: '/maindata/customs/getCustoms',
  // 获取海事信息列表
  GET_CUSTOMS_LIST: '/maindata/customs/getCustomsList',
  //同步mdg
  PRODUCT_SYNCMDG: '/maindata/materiel/sendMateriel',

  // 获取字典表
  DATA_DICT: '/maindata/dictData/listDataDictByDataType',
  // 获取人员信息 （公司）
  LIST_PERSON: '/maindata/person/listPerson',
  //驳回、审批
  UPDATE_IS_REJECT: '/maindata/product/approveProduct',
  //子类审批驳回
  UPDATE_IS_CHILDREN_REJECT: '/maindata/productDetail/approve',
  // 合同单价货币转换
  GET_EXCHANGE_CURRENCY: '/warehouse/storageLade/getExchangeCurrency',
  //同步MDG
  SYNC_MDG: '/maindata/productDetail/pushMDG',

  // 配置货物类型下拉框
  PRODUCT_TYPE: '/maindata/product/listProduct',
  // 商品子类下拉框
  GOODS_LIST_BY_TYPE: '/maindata/productDetail/listProductDetail',
  // 供应商 销售提单 商品下拉
  GOODS_SALE_API: '/maindata/product/listUsableProductByPage',
  // 商品属性新增
  GOODS_ATTR_ADD: '/maindata/productAttr/save',
  // 商品属性详情
  GOODS_ATTR_DETAIL: '/maindata/productAttr/getDetail',
  // 商品属性分页
  GOODS_ATTR_PAGE: '/maindata/productAttr/page',
  // 商品属性删除
  GOODS_ATTR_DELETE: '/maindata/productAttr/delete',
  // 更改商品属性状态
  GOODS_ATTR_CHANGESTATUS: '/maindata/productAttr/changeStatus',
  // 查询商品分类
  GOOD_ATTR_TYPE: '/maindata/sysProductCategory/selectList',
  // 商品属性维护导入
  GOODS_ATTR_IMPORT: '/maindata/productAttr/importExcel',
  //根据商品类型查询属性
  GOODS_QUERY_ATTR: '/maindata/productAttr/page',
  // 商品查询简化接口（目前用于仓储合同）
  PRODUCT_TYPE_CC: '/maindata/product/listSimpleProduct',
};
